// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

// import "@hotwired/turbo-rails"
// import "@hotwired/stimulus"
// import "@hotwired/stimulus-loading"

//= require jquery3
//= require popper
//= require bootstrap